import { createStyles, makeStyles, Theme } from '@material-ui/core'
import React, { useState } from 'react'
import { useTranslate, useShowContext } from 'react-admin'
import Button from '../../common/customized-mui-components/Button'
import { ChangePasswordDialog } from './CurrentUserDialogs'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.common.white,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      fontSize: 14,
    },
  }),
)

const ChangePasswordButton = () => {
  const { loading } = useShowContext()
  const [dialogOpen, setDialogOpen] = useState(false)
  const translate = useTranslate()
  const classes = useStyles()

  return (
    <>
      <ChangePasswordDialog
        open={dialogOpen}
        close={() => setDialogOpen(false)}
      />
      <Button
        className={classes.button}
        variant="contained"
        label={translate('resources.users.actions.changePassword')}
        disabled={loading}
        onClick={() => setDialogOpen(true)}
      />
    </>
  )
}

export default ChangePasswordButton
